import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ----------------------------------------------------------------------------
// Auth cookie bootstrap
// ----------------------------------------------------------------------------
// Always send HttpOnly auth cookies on fetch requests.
// Callers can opt out by explicitly passing credentials: 'omit' or 'same-origin'.
// ----------------------------------------------------------------------------
if (typeof window !== "undefined" && window.fetch) {
  const _origFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const next = { ...init };
    if (next.credentials === undefined) {
      next.credentials = "include";
    }
    return _origFetch(input, next);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
